import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-otp-limit',
  templateUrl: './otp-limit.component.html',
  styleUrls: ['./otp-limit.component.scss']
})
export class OtpLimitComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
